import React from 'react';
import { IconButton, IconButtonProps, Pane, Popover, Text } from 'evergreen-ui';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';
import { timeZoneSelector } from 'Features/App/appSlice';
import { CustomIntent, CustomIntentTypes } from './utils';

type StatusIconProps = IconButtonProps & {
  statusInfo?: string,
  icon: NonNullable<IconButtonProps['icon']>,
  intent: CustomIntentTypes,
  time: string,
  popover?: React.ReactNode,
  dataReceivedText?: string,
}

const useStyle = createUseStyles({
  info: {
    padding: '10px',
    display: 'grid',
    justifyContent: 'center',
    minWidth: 'max-content',
    alignItems: 'center',
  },
});

function InternalStatusIcon({
  statusInfo,
  icon,
  intent,
  popover,
  time,
  dataReceivedText,
}: StatusIconProps) {
  const classes = useStyle();
  const selectedZone = useSelector(timeZoneSelector);
  return (
    <Popover
      content={(
        <Pane className={classes.info}>
          {
            dataReceivedText
              ? (
                <Pane>
                  {time && (<Text>{time ? `${time} UTC${selectedZone.selectedUserTimeZone} - ` : ''}</Text>)}
                  <Text
                    style={dataReceivedText !== 'Поступление программ наблюдения: Неизвестно'
                      ? { color: CustomIntent[intent] }
                      : { color: '#425A70' }}
                  >
                    {dataReceivedText}
                  </Text>
                </Pane>
              )
              : (
                <Pane>
                  {time && (<Text>{time ? `${time} UTC${selectedZone.selectedUserTimeZone} - ` : ''}</Text>)}
                  <Text>{statusInfo}</Text>
                </Pane>
              )
          }
          {popover && (<Text justifySelf="start">{popover}</Text>)}
        </Pane>
      )}
      trigger="click"
    >
      <IconButton
        appearance="minimal"
        icon={icon}
        style={{ color: CustomIntent[intent] }}
        // @ts-ignore
        intent={CustomIntent[intent] ? 'default' : 'none'}
      />
    </Popover>
  );
}

export const StatusIcon = React.memo(InternalStatusIcon);
StatusIcon.displayName = 'StatusIcon';
export default StatusIcon;
